import { render, staticRenderFns } from "./marginApplication-detail.vue?vue&type=template&id=49e2d3ba&"
import script from "./marginApplication-detail.vue?vue&type=script&lang=js&"
export * from "./marginApplication-detail.vue?vue&type=script&lang=js&"
import style0 from "./marginApplication-detail.vue?vue&type=style&index=0&id=49e2d3ba&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports